import React, { useMemo } from 'react';
import UsersInfoPanel from './Components/UsersInfoPanel';
import { Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import UsersProgressPanel from './Components/UsersProgressPanel';

const UsersSingleViewMain: React.FC<any> = (props: any) => {

    return useMemo(() => (

        <>

            <Space />

            <UsersInfoPanel {...props} />

            <Space />

            <UsersProgressPanel {...props} />

        </>

    ), [props]);

}

export default UsersSingleViewMain;
